import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { MobileNavigationLinks } from "./MobileNavigationLinks";

export function NavigationLinks() {
  const navItems = [
    { path: "/", label: "HOME" },
    { path: "/about", label: "ABOUT" },
    { path: "/contact", label: "CONTACT" },
    { path: "/work", label: "WORK" },
    { path: "https://github.com/TheoGreenslade", label: "GITHUB" },
    { path: "https://www.linkedin.com/in/theogreenslade/", label: "LINKEDIN" },
  ];

  // Split navItems into two columns
  const columns = [navItems.slice(0, 3), navItems.slice(3, 6)];

  return (
    <>
      {/* Desktop navigation */}
      <Box
        sx={{
          // position: 'absolute',
          // top: 32,
          // right: 64,
          display: { xs: "none", md: "flex" },
          zIndex: 10,
          flexDirection: "row",
          gap: 12,
        }}
      >
        {columns.map((col, colIdx) => (
          <Box
            key={colIdx}
            sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
          >
            {col.map((item) =>
              item.path.startsWith("http") ? (
                <a
                  key={item.path}
                  href={item.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <Typography
                    variant="h4"
                    lineHeight={1}
                    sx={{
                      fontWeight: 400,
                      fontSize: "2.5rem",
                      cursor: "pointer",
                      transition: "opacity 0.2s",
                      userSelect: "none",
                      color: "text.primary",
                      "&:hover": {
                        opacity: 0.6,
                      },
                    }}
                  >
                    {item.label}
                  </Typography>
                </a>
              ) : (
                <Link
                  key={item.path}
                  to={item.path}
                  style={{ textDecoration: "none" }}
                >
                  <Typography
                    variant="h4"
                    lineHeight={1}
                    sx={{
                      fontWeight: 400,
                      fontSize: "2.5rem",
                      cursor: "pointer",
                      transition: "opacity 0.3s",
                      userSelect: "none",
                      color: "text.primary",
                      "&:hover": {
                        opacity: 0.6,
                      },
                    }}
                  >
                    {item.label}
                  </Typography>
                </Link>
              ),
            )}
          </Box>
        ))}
      </Box>
      {/* Mobile navigation */}
      <MobileNavigationLinks />
    </>
  );
}
